import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

import { computed, onMounted, ref, watch } from "vue";
import { appStore, layoutStore, projectSaveStore, cyStore } from "@/hooks";
import { FlexBox, TextButton, Separator } from "@/components/common";
import Typography from "@/components/common/display/content/Typography.vue";
import { Cytoscape } from "./base";
import { TimNode, TimLink } from "./tim";


/**
 * Creates a Cytoscape graph containing artifact types are nodes
 * and links between them as edges.
 */
const __default__ = {
  name: "CreatorTree",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const graph = ref(cyStore.buildCreatorGraph());
const loading = ref(false);

const className = computed(() => {
  if (!appStore.isLoading && !loading.value) {
    return "artifact-view visible";
  } else {
    return "artifact-view";
  }
});

onMounted(() => {
  layoutStore.setGraphLayout("creator");
});

watch(
  () => [projectSaveStore.graphNodes, projectSaveStore.graphEdges],
  () => {
    loading.value = true;

    // Wait for 0.1s width animation before resetting the layout.
    setTimeout(() => {
      layoutStore.setGraphLayout("creator");
      loading.value = false;
    }, 100);
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(FlexBox), {
      justify: "between",
      align: "center"
    }, {
      default: _withCtx(() => [
        _createVNode(Typography, {
          variant: "subtitle",
          value: "Artifact Type Tree"
        }),
        _createVNode(_unref(TextButton), {
          text: "",
          label: "Center Graph",
          icon: "graph-center",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(cyStore).resetWindow('creator')))
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(Separator)),
    _createVNode(_unref(Cytoscape), {
      id: "cytoscape-tim",
      graph: graph.value,
      class: _normalizeClass(className.value),
      "data-cy": "view-tim-tree"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(projectSaveStore).graphNodes, (node) => {
          return (_openBlock(), _createBlock(_unref(TimNode), _mergeProps({
            key: node.artifactType
          }, node), null, 16))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(projectSaveStore).graphEdges, (edge) => {
          return (_openBlock(), _createBlock(_unref(TimLink), _mergeProps({
            key: edge.sourceType + edge.targetType
          }, edge), null, 16))
        }), 128))
      ]),
      _: 1
    }, 8, ["graph", "class"])
  ]))
}
}

})